import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=137fee9e"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"
import style0 from "./Loader.vue?vue&type=style&index=0&id=137fee9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports